export default __webpack_public_path__ + "media/images/radio-selected-d944dae3e00115064736a99af27c9dde.svg";